import config from '../config';


export const calculateAramexRate = async (selectedCountry, totalWeight, subtotalValue, selectedCity,postcode) => {
  
 const response = await fetch(
          `${config.apiUrl}/api/shipping/aramex/rate`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              destinationCountry: selectedCountry,
              weight: totalWeight,
              value: subtotalValue,              
              destinationCity: selectedCity,
              postcode
            }),
          }
        );

//   if (!response.ok) throw new Error('Failed to fetch Aramex rate');
  return response.json();

    };

    export const fetchAramexCities = async (country) => {
      const response = await fetch(
        `${config.apiUrl}/api/shipping/aramex/cities`,
        {
          method: "POST",   
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country }),
        }   
      );    
        if (!response.ok) throw new Error('Failed to fetch Aramex cities');
        return response.json();
    };

    export const createShipment = async (orderId) => {
  try {
    const response = await fetch(`${config.apiUrl}/api/shipping/aramex/create-shipment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },  
      body: JSON.stringify({ orderId: orderId }),
    });

    const result = await response.json();

    if (result.success) {
      console.log("Shipment created successfully", result);
    } else {
      console.error("Shipment creation failed", result);
    }
  } catch (error) {
    console.error("Error creating shipment:", error);
  }
};